<template>
	<div>
		<NavBar />

		<div style="min-height: 80vh">
			<slot />
		</div>

		<CustomFooter />
		<!--<CookieBanner />-->
	</div>
</template>

<script>
	import NavBar from "./components/navbar.vue";
	import CustomFooter from "./components/footer.vue";
	//import CookieBanner from "./components/cookie.vue";

	export default {
		name: "PortalLayout",

		data() {
			return {};
		},

		components: {
			NavBar,
			CustomFooter,
            //CookieBanner
		}
	};
</script>
